import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useChangeEmail() {
  const tError = useErrorTranslation();
  const [sendOldIsPending, setSendOldIsPending] = useState(false);
  const [sendNewIsPending, setSendNewIsPending] = useState(false);
  const [checkIsPending, setCheckIsPending] = useState(false);

  const [sendOldError, setSendOldError] = useState<string>("");
  const [sendNewError, setSendNewError] = useState<string>("");
  const [checkError, setCheckError] = useState<string>("");

  const [sendOldIsCompleted, setSendOldIsCompleted] = useState<null | boolean>(null);
  const [sendNewIsCompleted, setSendNewIsCompleted] = useState<null | boolean>(null);
  const [checkIsCompleted, setCheckIsCompleted] = useState<null | boolean>(null);

  const sendOldCodeHandler = useCallback(async (oldEmail: string) => {
    try {
      if (!oldEmail) return;
      setSendOldIsPending(true);
      setSendOldError("");

      const response = await AccountMpProvider.changeEmailSendCodeOld({
        oldEmail,
      });

      if (response instanceof RpcMpProviderSuccessResponse) {
        setSendOldIsCompleted(true);
      } else {
        setSendOldError(tError(response.message));
        setSendOldIsCompleted(false);
      }
    } catch ({ message }) {
      setSendOldError(tError(message));
      setSendOldIsCompleted(false);
    } finally {
      setSendOldIsPending(false);
    }
  }, []);

  const sendNewCodeHandler = useCallback(async (newEmail: string, oldCode?: string) => {
    try {
      if (!newEmail) return;
      setSendNewIsPending(true);
      setSendNewError("");

      const response = await AccountMpProvider.changeEmailSendCodeNew({
        newEmail,
        oldCode,
      });
      if (response instanceof RpcMpProviderSuccessResponse) {
        setSendNewIsCompleted(true);
      } else {
        setSendNewError(tError(response.message));
        setSendNewIsCompleted(false);
      }
    } catch ({ message }) {
      setSendNewError(tError(message));
      setSendNewIsCompleted(false);
    } finally {
      setSendNewIsPending(false);
    }
  }, []);

  const checkCodeHandler = useCallback(async (newCode: string) => {
    try {
      if (!newCode) return;

      setCheckIsPending(true);
      setCheckError("");

      const response = await AccountMpProvider.changeEmailCheckCodeNew({ newCode });
      if (response instanceof RpcMpProviderSuccessResponse) {
        setCheckIsCompleted(true);
      } else {
        setCheckError(tError(response.message));
        setCheckIsCompleted(false);
      }
    } catch ({ message }) {
      setCheckError(tError(message));
      setCheckIsCompleted(false);
    } finally {
      setCheckIsPending(false);
    }
  }, []);

  return {
    sendOldCodeHandler,
    sendOldError,
    sendOldIsPending,
    setSendOldIsPending,
    sendOldIsCompleted,

    sendNewCodeHandler,
    sendNewError,
    sendNewIsPending,
    setSendNewIsPending,
    sendNewIsCompleted,

    checkCodeHandler,
    checkError,
    checkIsPending,
    setCheckIsPending,
    checkIsCompleted,
  };
}
